module.exports = __webpack_public_path__ + "img/emptyradio.3795c428.svg";